import type { ApiMeta } from "@/apis/types";

/**
 * API metadata for WSDOT Bridge Clearances API
 */
export const wsdotBridgeClearancesApiMeta: ApiMeta = {
  name: "wsdot-bridge-clearances",
  baseUrl: "https://www.wsdot.wa.gov/traffic/api/bridges/clearancerest.svc",
};
